export default "__VITE_ASSET__e8ec25b0__"